"use client";

import Link from "next/link";
import { useTranslation } from "@/i18n";

export function LegalContent() {
    const { t } = useTranslation();
    const { legal } = t;

    return (
        <div className="pt-24 pb-16 px-6 md:px-8">
            <div className="mx-auto max-w-3xl">
                {/* Back link */}
                <Link
                    href="/"
                    className="text-sm text-text-muted hover:text-text transition-colors inline-flex items-center gap-1.5 mb-10"
                >
                    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-3.5 h-3.5" aria-hidden="true"><path d="M10 3L5 8l5 5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    {legal.backHome}
                </Link>

                {/* Page header */}
                <div className="mb-14">
                    <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-text mb-3">
                        {legal.pageTitle}
                    </h1>
                    <p className="text-sm text-text-muted">{legal.lastUpdated}</p>
                </div>

                {/* Legal Notice */}
                <section id="legal-notice" className="mb-16 scroll-mt-24">
                    <h2 className="text-xl font-semibold text-text mb-6 pb-3 border-b border-border">
                        {legal.legalNotice.title}
                    </h2>
                    <dl className="space-y-3">
                        {legal.legalNotice.rows.map((row) => (
                            <div key={row.label} className="grid grid-cols-[180px_1fr] gap-4">
                                <dt className="text-sm font-medium text-text-secondary">{row.label}</dt>
                                <dd className="text-sm text-text-muted">{row.value}</dd>
                            </div>
                        ))}
                    </dl>
                </section>

                <div className="divider-mars mb-16" />

                {/* Privacy Policy */}
                <section id="privacy" className="mb-16 scroll-mt-24">
                    <h2 className="text-xl font-semibold text-text mb-8 pb-3 border-b border-border">
                        {legal.privacy.title}
                    </h2>
                    <div className="space-y-8">
                        {legal.privacy.sections.map((section) => (
                            <div key={section.title}>
                                <h3 className="text-base font-semibold text-text mb-3">
                                    {section.title}
                                </h3>
                                <ul className="space-y-2">
                                    {section.body.map((paragraph, i) => (
                                        <li
                                            key={i}
                                            className="text-sm text-text-muted leading-relaxed pl-3 border-l border-border"
                                        >
                                            {paragraph}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </section>

                <div className="divider-mars mb-16" />

                {/* Cookies */}
                <section id="cookies" className="mb-16 scroll-mt-24">
                    <h2 className="text-xl font-semibold text-text mb-6 pb-3 border-b border-border">
                        {legal.cookies.title}
                    </h2>
                    <ul className="space-y-3">
                        {legal.cookies.body.map((paragraph, i) => (
                            <li
                                key={i}
                                className="text-sm text-text-muted leading-relaxed pl-3 border-l border-border"
                            >
                                {paragraph}
                            </li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    );
}
